require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-science-and-mobility-1-12-1-4.json") })
        }
      }, "path---data-science-and-mobility-1-12-1-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-science-and-mobility-1-12-1-4!./.cache/json/data-science-and-mobility-1-12-1-4.json
// module id = 392
// module chunks = 231608221292675